import {
    InitialMapOptionsSetter,
    ReturnedSelectedMapOptions,
} from 'app/shared/map_options/InitialMapOptions';
import { View } from 'app/shared/collections/view';
import { AvailableMapOptions } from 'app/shared/map_options/InitialMapOptionsAsset';
import { merge } from 'lodash';
import { ILocalStorageService } from 'angular-local-storage';

/**
 * This class sets the default map options for map options that aren't in the Assets tab (ie Zones)
 */

export class NonAssetInitialDefaultMapOptionsSetter extends InitialMapOptionsSetter {
    protected _localStorageService: ILocalStorageService;
    protected _panelKey: string;
    protected _availableMapOptions: AvailableMapOptions;

    constructor(localStorageService: ILocalStorageService, view: View, panelKey: string) {
        super(localStorageService, panelKey, view);
    }

    protected _getInitialDefaultMapOptions(defaultMapOptions: {
        [key: string]: string;
    }): ReturnedSelectedMapOptions {
        const mapOptionsFromLocalStorage = this._getDefaultsFromLocalStorage();
        const mapOptionsFromApi = this._getDefaultsFromViewComponent();
        const defaultSelectedMapOptions = merge(
            {},
            defaultMapOptions,
            mapOptionsFromApi,
            mapOptionsFromLocalStorage,
        );
        const selectedMapOptions = Object.assign({}, defaultSelectedMapOptions);
        return { defaultSelectedMapOptions, selectedMapOptions };
    }
}
